
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accelerated",
      function () {
        return require("private-next-pages/accelerated/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accelerated"])
      });
    }
  